
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IRole } from '@my-aon/auth';
import { SharedModule } from '@my-aon/shared';
import { FormRoleDetailsComponent } from '../../components/form-role-details/form-role-details.component';

@Component({
    selector: 'app-dialog-role-details',
    standalone: true,
    imports: [SharedModule, FormRoleDetailsComponent],
    templateUrl: './dialog-role-details.component.html',
    styleUrl: './dialog-role-details.component.scss',
})
export class DialogRoleDetailsComponent {
    readonly dialogRef = inject<MatDialogRef<DialogRoleDetailsComponent>>(MatDialogRef);
    readonly data = inject<{ data: IRole }>(MAT_DIALOG_DATA);

    readOnly = true;

    submited: boolean = false;

    close = (e: IRole | null): void => {
        this.dialogRef.close(e);
    };

    onSubmit = (e?: any): void => {
        if (this.submited === false) this.submited = true;
    };
}
